module.exports = __webpack_public_path__ + "static/media/dark-Creative-demo.e22b2d6f.png";